import { SliderUnstyled, type SliderUnstyledProps } from '@mui/base'
import { forwardRef } from 'react'

import './Slider.scss'

const Slider = forwardRef<HTMLElement, SliderUnstyledProps>(function Slider(
  props,
  ref
) {
  return (
    <SliderUnstyled
      ref={ref}
      slotProps={{
        rail: { className: 'a-Slider__rail' },
        root: { className: 'a-Slider' },
        thumb: { className: 'a-Slider__thumb' },
        track: { className: 'a-Slider__track' },
      }}
      {...props}
    />
  )
})

export default Slider
